import { store } from 'app/store/store';
import { getCurrentRoundNumber, getIsAutomation } from 'app/store/userRoom';

export const isZeroRound = () => getCurrentRoundNumber(store.getState()) === 0 && getIsAutomation(store.getState());
